import { useState } from 'react';
import { Tabs as CTabs } from '@consta/uikit/Tabs';
import { IconComponent } from '@consta/uikit/Icon';

export const Tabs = ({
  items,
  active,
  onChange,
  className = '',
}: {
  items: Item[];
  active: string;
  onChange?: (value: string) => void;
  className?: string;
}) => {
  const [value, setValue] = useState<string | null>(active ?? items[0].value);

  const __items: { [value: string]: string } = items.reduce(
    (pv, cv) => ({ ...pv, [cv.value]: cv.label }),
    {},
  );

  const onChangeTab = ({ value }: { value: string }) => {
    setValue(value);
    typeof onChange === 'function' && onChange(value);
  };

  return (
    <CTabs
      value={value}
      className={className}
      onChange={onChangeTab}
      items={items.map(({ value }) => value)}
      getItemLabel={(value) => __items[value]}
    />
  );
};

export type Item = {
  value: string;
  label: string;
  image?: IconComponent;
};
